import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=771aeba2&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771aeba2')) {
      api.createRecord('771aeba2', component.options)
    } else {
      api.reload('771aeba2', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=771aeba2&", function () {
      api.rerender('771aeba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85aCiZ4xA6Rje/JS/comp/FavElement.vue"
export default component.exports